<template>
<div
    v-resize="onResize"
>
    <div 
        :class="{ 'summaries_container' : true, 'container_with_sign_in_as_footer' : $rc.$state.showSignedInAsFooter()}"
    >

        <v-banner
            v-if="ad_hoc_dnd != null && ad_hoc_dnd != '' && cur_display_mode == 'mobile'"
            two-line
            transition="slide-y-transition"
        >
            You've put yourself into Do Not Disturb mode until {{ getDNDEndTime() }}. <a v-on:click="onExitDND">End now.</a>
        </v-banner>
        
        
        <m-needs-attention-counts
            :value="needs_attention_counts"
        />

        <!-- Filter Chips -- let users know how they have filtered their conversation -->
         <div
            class="chip-container"
            v-if="show_spam_conversations"
        >
            <v-chip
                class="ma-2"
                color="red"
                label
                outlined
            >
                Blocked (spam) conversations
            </v-chip>
            
        </div>

        <div
            v-if="show_archived_conversations"
            class="chip-container"
        >
            <v-chip
                class="ma-2"
                label
                outlined
            >
                Archived Conversations
            </v-chip>
        </div> 

        <div
            class="chip-container"
            v-if="participant_state_description"
        >
            <v-chip
                class="ma-2"
                label
                outlined
            >
                {{participant_state_description}}
            </v-chip>
        </div>

        <div
            class="chip-container"
            v-if="message_content_full_text_search != null"
        >
            <v-chip
                class="ma-2"
                label
                outlined
                close
                style="height: auto; min-height: 32px; white-space: normal;"
                @click:close="onCloseMessageFullTextSearch"
            >
                Search: {{message_content_full_text_search}}
            </v-chip>
        </div>

        <div
            v-if="message_tag_search != null"
            class="chip-container"
        >
            <m-rc-tag-display
                :value="message_tag_search.values"
                :separator="message_tag_search.type"
                show_close
                v-on:close="onCloseMessageTagSearch"
            />

        </div>

       

        <m-conversation-summary
            v-for="(summary,key) in summaries_to_show"
            :summary="summary"
            :key="key"
            v-on:select-conversation="onSelectConversation"
            v-on:conversation-action="onConversationAction"
            :selected_conversation_id="selected_conversation_id"
            :can_transmit="can_transmit"
        >
        </m-conversation-summary>

    </div>

    <m-edit-tag-filter-dialog
        ref="edit-tag-filter-dialog"
    />

    <!-- Action buttons at the bottom left of page-->
    <div 
        :class="{ 'conversation_filter_container' : true, 'container_with_sign_in_as_footer' : $rc.$state.showSignedInAsFooter() }"
    >
        
        <v-menu
            v-if="show_add_to_home_screen"
            top
            offset-y
        >
            <template v-slot:activator="{ on }">
                    <v-btn
                        v-on="on"
                        color="grey"
                        dark
                        fab
                        style="margin-right: 8px;"
                    >
                        <v-icon>mdi-menu</v-icon>
                    </v-btn>
            </template>

             <v-list>
                 <v-list-item
                    v-on:click="onClickAddToHomeScreen()"
                    v-if="show_add_to_home_screen"
                >
                    <v-list-item-title>Add RedChirp to your home screen...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>

        <v-menu
            top
            offset-y
            v-model="show_summary_context_menu"
        >
            <template v-slot:activator="{  }">
                
                <v-btn
                    color="grey"
                    dark
                    fab
                    v-on:click="onClickSummaryContextMenu"
                    style="margin-right: 8px;"
                >
                    <v-icon>mdi-filter-menu</v-icon>
                </v-btn>
            </template>

            <!-- Bit of a hack to list the two different values, if the menu items is extended in the future, consolidate the different boolean toggles into the item as well -->
            <v-list>
                
                <div
                    v-for="(item, index) in menu_items"
                    :key="index"
                >

                    <v-list-item
                        v-if="item.text != 'divider'"
                        v-on:click="onClickMenuItem(item)"
                    >
                        <template v-slot:default="{ }">
                            <v-list-item-action>
                                <v-checkbox
                                    v-if="item.cb_value != null"
                                    color="primary"
                                    :input-value="item.cb_value"
                                ></v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                                <v-list-item-title>{{item.text}}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                    </v-list-item>

                    <v-divider 
                        v-else
                    />

                </div>
                
            </v-list>
        </v-menu>
            
        <v-btn
            :color="start_conversation_button_color"
            dark
            fab
            v-on:click="onStartChat"
            style="margin-right: 8px;"
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
                    
    </div>
</div>
</template>

<script>

const Utils = require('@/js/utils.js');
const Time = require('@/js/time.js');

export default 
{
    props: {
        start_conversation_button_color: {
            type: String,
            default: 'primary'
        },

        can_transmit: {
            type: Boolean,
            default: () => { return false; }
        },
        ad_hoc_dnd: {
            type: Object,
            default: () => { return null; }
        },
        cur_display_mode: {
            type: String,
            default: () => { return null; }
        },
        show_archived_conversations: {
            type: Boolean,
            default: () => { return false; }
        },
        show_active_conversations: {
          type: Boolean,
          default: () => { return true; }
        },
        show_spam_conversations: {
          type: Boolean,
          default: () => { return false; }
        },
        show_read_conversations: {
            type: Boolean,
            default: () => { return true; }
        },
        show_unread_conversations: {
            type: Boolean,
            default: () => { return true; }
        },
        participant_state: {
            type: String,
            default: () => { return 'any'; }
        },

        message_content_full_text_search: {
            type: String,
            default: () => { return null; }
        },

        message_tag_search: {
            type: Object,
            default: () => { return null; }
        },

        organization_id: {
            type: String,
            default: () => { return this.$rc.$profile.getOrganizationId(); }
        },
    },

    data() {
        return {
            all_summaries: [],
            needs_attention_counts: [],
            open_contact_request_info: {'organization_id' : null, 'employee_id' : null, 'open_contact_requests' : 0},
            selected_conversation_id: 'no-conversation-selected',
            scroll_bar_width: 16,
            show_summary_context_menu: false,
        }
    },

    mounted () {
        this.onResize();
    },

    methods: {
        getDNDEndTime() {
            return Time.getPeriodClockTime(this.ad_hoc_dnd.time_stop);
        },

        onExitDND() {
            this.$emit('exit-dnd','');
        },

        update(summaries) 
        {
            this.all_summaries = summaries.asArray();
            this.needs_attention_counts = summaries.needs_attention_counts;
        },

        setSelectedConversationId(id)
        {
            this.selected_conversation_id = id;
        },

        onSelectConversation(conversation_id)
        {
            this.$emit('select-conversation',conversation_id);
        },

        onConversationAction(action)
        {
            this.$emit('conversation-action',action);
        },

        clearSelectedConversation()
        {
            this.$emit('clear-selected-conversation');
        },

        onStartChat()
        {
            this.$emit('start-new-chat');
        },

        onClickMenuItem(action)
        {
            if ( action.action == 'message_content_full_text_search' )
            {
                this.$rc.prompt({
                    'title' : 'Full text search messages',
                    'label' : 'Full text search messages',
                    'value' : '',
                    'after_prompt' : (value) => {

                        if ( value.length < 3 )
                        {
                            this.$rc.alert('Too short', 'Enter at least three characters');
                            return;
                        }

                        action.value = value;
                        this.$emit('menu-action', action);

                        return;
                    }
                });
                return;
            }

            if ( action.action == 'message_tag_search' )
            {
                this.$refs['edit-tag-filter-dialog'].showDialog(
                {
                    'organization_id': this.organization_id, 
                    'applies_to': 'conversation',
                    'filter': this.message_tag_search,
                    'show_archived': false,
                    'ok_button_text': 'Search',
                    'on_save': (new_filter) => {
                        action.value = new_filter;
                        this.$emit('menu-action', action);
                    }
                }
            );
            } 


          this.$emit('menu-action', action);
        },

        onClickSummaryContextMenu()
        {
            this.show_summary_context_menu = true;
        },

        onResize()
        {
            this.scroll_bar_width = Utils.getScrollbarWidth();
        },

        onClickAddToHomeScreen()
        {
            this.$router.push({
                'name': 'ios-to-instructions'
            });
        },

        onCloseMessageFullTextSearch()
        {
            this.$emit('menu-action', {
                'text' : 'Search Messages...',
                'action' : 'message_content_full_text_search',
                'cb_value' : null,
                'value' : null,
            });
        },

        onCloseMessageTagSearch()
        {
             this.$emit('menu-action', {
                'text' : 'Search Tags...',
                'action' : 'message_tag_search',
                'cb_value' : null,
                'value' : null,
            });
        },
    },

    computed: {

        menu_items()
        {
            let ret = [];

            ret.push({
                'text' : 'Active Conversations',
                'action' : 'toggle_active_conversations',
                'cb_value': this.show_active_conversations,
            });

            ret.push({
                'text' : 'Archived Conversations',
                'action' : 'toggle_archived_conversations',
                'cb_value' : this.show_archived_conversations,
            });


            ret.push({
                'text' : 'Blocked (spam) conversations',
                'action' : 'toggle_spam_conversations',
                'cb_value' : this.show_spam_conversations,
            });

            ret.push({
                'text' : 'divider',
                'action' : 'toggle_spam_conversations',
            });       

            ret.push({
                'text' : 'Read',
                'action' : 'toggle_read_conversations',
                'cb_value' : this.show_read_conversations,
            });

            ret.push({
                'text' : 'Unread',
                'action' : 'toggle_unread_conversations',
                'cb_value' : this.show_unread_conversations,
            });

            ret.push({
                'text' : 'divider',
                'action' : 'toggle_spam_conversations',
            });       


            ret.push({
                'text' : 'Has at least one message',
                'action' : 'filter_participant',
                'cb_value' : this.participant_state.toLowerCase() == 'any',
                'value': 'any',
            });

            ret.push({
                'text' : 'You have sent a message',
                'action' : 'filter_participant',
                'cb_value' : this.participant_state.toLowerCase() == 'current-user-has-sent-a-message',
                'value' : 'current-user-has-sent-a-message',
            });

            ret.push({
                'text' : 'You have not sent a message',
                'action' : 'filter_participant',
                'cb_value' : this.participant_state.toLowerCase() == 'current-user-has-not-sent-a-message',
                'value' : 'current-user-has-not-sent-a-message',
            });

            ret.push({
                'text' : 'divider',
                'action' : 'toggle_spam_conversations',
            });
            
            ret.push({
                'text': 'Update unread counts...',
                'action': 'update_unread_counts',
                'cb_value': null,
            });

            ret.push({
                'text' : 'divider',
                'action' : 'toggle_spam_conversations',
            });  

            ret.push({
                'text': 'View conversation with...',
                'action': 'message_contact_search',
                'cb_value': null,
            });
            
            ret.push({
                'text': 'Search using tags...',
                'action': 'message_tag_search',
                'cb_value': null,
            });

            ret.push({
                'text' : 'Search Messages...',
                'action' : 'message_content_full_text_search',
                'cb_value' : null,
            });

            return ret;
        },

        summaries_to_show()
        {
            let ret = [];

            let include_states = [];
      
            if ( this.show_active_conversations ) include_states.push('active');
            if ( this.show_archived_conversations ) include_states.push('archived');
            if ( this.show_spam_conversations ) include_states.push('spam');


            for (let i =0; i < this.all_summaries.length; i++)
            {
                let cur_summary = this.all_summaries[i];

               
                if ( include_states.includes(cur_summary.data.state) )
                {
                    ret.push(cur_summary);
                }
            }

            return ret;
        },

        show_add_to_home_screen()
        {
            return this.$rc.offerAddToHomeScreen();
        },

        participant_state_description()
        {
            let state = this.participant_state.toLowerCase();

            if ( state == 'any' ) return null;
            if ( state == 'current-user-has-sent-a-message' ) return 'You have sent a message';
            if ( state == 'current-user-has-not-sent-a-message' ) return 'You have not sent a message';
            if ( state == 'no-employee-has-sent-a-message' ) return 'No team member has sent a message';

            return null;
        },
    },



    
}
</script>

<style scoped>

.summaries_container
{
    position: fixed; 
    top: 45px; 
    bottom: 0; 
    left: 0; 
    width: 350px; 
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-width: thin;
    padding-top: 5px;

    z-index: 3;

    background-color: white;
    border-right: 1px solid rgb(232,232,232);

    padding-bottom: 75px;    /* allows the user to scroll the (+) (or menu) button out of the way of the last conversation... */
}


.conversation_filter_container
{
    position: fixed;
    width: 330px;
    height: 70px;
    left: 0px;
    bottom: 0px;

    z-index: 4;

    text-align: right;
}

.container_with_sign_in_as_footer
{
    bottom: 30px;
}

.start_new_chat_container
{
    position: fixed;
    width: 80px; 
    height: 70px; 
    left: 250px;
    bottom: 70px;

    z-index: 4;
}

.start_new_chat_container_with_narrow_scrollbars
{
    width: 65px;
}

@media screen and (max-width: 960px) 
{
    .summaries_container 
    {
        width: unset;
        right: 0px;
    }

    .start_new_chat_container
    {
        left: unset;
        right: 0px;
    }

    .conversation_filter_container
    {
        left: unset;
        right: 0px;
    }
}

.chip-container
{
    text-align: center; 
    margin-top: -7px; 
    margin-bottom: -7px;
}

.archived_conversations, .spam_conversations, .participant_state
{
    width: 230px; 
    margin: auto; 
    border: 1px solid rgba(0,0,0,0.2); 
    font-size: 12px; 
    text-align: center; 
    padding: 3px; 
    border-radius: 3px; 
    margin-top: 3px;
    margin-bottom: 3px;
}

.archived_conversations, .participant_state
{
    background-color: rgba(0,0,0,0.1)
}

.spam_conversations
{
    background-color: rgba(255,0,0,0.1)
}

</style>